export default __webpack_public_path__ + "static/media/retro-prints.651e4d4d.svg";